import { AppSession, Organization } from '@prisma/client'
import { useEffect, useRef, useState } from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { Api } from '~/core/trpc'
import { ChatSocketPayload } from '~/features/chatV3/common'
import { SocketClient } from '~/plugins/socket/client'

type Props = {
  organization: Organization
  organizationMemberAgent?: OrganizationMemberFromContext
  appSession?: AppSession
}

export const useFatalError = (props: Props) => {
  const { organization, appSession } = props

  const refProps = useRef<Props>(props)
  const refVisible = useRef(false)

  const updateMutation = Api.appSession.update.useMutation()

  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    const value = appSession?.isExecutionError

    refVisible.current = value
    setVisible(value)
  }, [appSession?.isExecutionError])

  useEffect(() => {
    if (refVisible.current && !isVisible) {
      setVisible(true)
    }
  }, [refVisible.current])

  useEffect(() => {
    refProps.current = props
  }, [props])

  SocketClient.useEvent<ChatSocketPayload>(
    `organization-${organization.id}-chat`,
    async payload => {
      const isConcerned =
        refProps.current?.organizationMemberAgent?.id ===
        payload.organizationMemberId

      if (isConcerned) {
        if (payload.type === 'error') {
          refVisible.current = true
        }
      }
    },
  )

  const display = () => {
    setVisible(true)
  }

  const close = async () => {
    setVisible(false)

    await updateMutation
      .mutateAsync({
        where: {
          id: appSession.id,
        },
        data: {
          isExecutionError: false,
        },
      })
      .catch(error => console.error('Unknown Error', error))
  }

  return {
    close,
    display,
    isVisible,
  }
}
